// @flow

export default {
  Before: ('Before': 'Before'),
  After: ('After': 'After'),
};
